import React from 'react';

export const InitialContextValue = {
  openModal: false,
  showCookieModal: false,
  showAccommodationModal: false,
};

export const AppContext = React.createContext(InitialContextValue);
